
import axios from "axios";

export async function sendSlackMessage(message: string, canal: string) {
  const url = "https://simulateurtransport.vercel.app/api/sendSlackMessage";
  const body = {
    message: message,
    canal: canal,
  };
  try {
    const response = await axios.post(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: (status) => status >= 200 && status < 300,
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'envoi du message:", error);
    throw error;
  }
}
